module.exports = __webpack_public_path__ + "assets/img/sm2.79d229bc.png";